import Component from './MyProfile';

export default Component;
